import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './left.styl'

export default class Left extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}
